import(/* webpackMode: "eager" */ "C:\\Users\\User\\Documents\\alchemycandy5000\\magikalcandy\\src\\app\\page.tsx");
